import React from 'react';

import Modal from '../Modal/Modal';

import './ConfirmationModal.css';

const ConfirmationModal = () => {
  return (
    <Modal id="confirmation-modal" className="ConfirmationModal">
      <div className="modal-body p-4" />

      <div className="modal-footer px-4">
        <button id="confirm-true" type="button" className="btn btn-primary"> OK </button>
        <button id="confirm-false" type="button" className="btn btn-secondary"> Cancel </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmationModal/ConfirmationModal.js